import { useQuery } from 'react-query';
import axios from 'axios';
import { INDEX_PAGE } from './useInvoices'; // item 1480 — whole index, not a 100-row page
import { PurchaseOrdersDto } from '../models/purchaseOrder';

export const getPurchaseOrders = async (): Promise<PurchaseOrdersDto> => {
  const apiUrl = process.env.REACT_APP_BASIX_API || '';
  const { data } = await axios.get(`${apiUrl}PurchaseOrder/Search`, { params: { pageSize: INDEX_PAGE } });
  return data;
};

const usePurchaseOrders = () => useQuery('purchaseOrders', getPurchaseOrders);

export default usePurchaseOrders;
